<nb-card class="dialog">
  <nb-card-header>
    <h4>{{ "pages.creator.kb.title" | translate }}</h4>
  </nb-card-header>
  <nb-card-body>
    <p class="intro">{{ "pages.creator.kb.description" | translate: { title: item.title } }}</p>

    <div class="field">
      <label class="label" for="kb-bucket">{{ "pages.creator.kb.bucket" | translate }}</label>
      <app-orbi-loader *ngIf="buckets === null" [size]="64"></app-orbi-loader>
      <p *ngIf="buckets && buckets.length === 0" class="hint">{{ "pages.creator.kb.noBuckets" | translate }}</p>
      <nb-select
        *ngIf="buckets && buckets.length > 0"
        id="kb-bucket"
        fullWidth
        [placeholder]="'pages.creator.kb.bucketPlaceholder' | translate"
        [(selected)]="bucketId"
      >
        <nb-option *ngFor="let b of buckets" [value]="b.id">{{ b.name }}</nb-option>
      </nb-select>
    </div>

    <nb-checkbox [(checked)]="includeSolutions">{{ "pages.creator.kb.solutions" | translate }}</nb-checkbox>
    <p class="hint">{{ "pages.creator.kb.solutionsHint" | translate }}</p>
  </nb-card-body>
  <nb-card-footer>
    <button type="button" nbButton status="danger" outline (click)="cancel()" [disabled]="working">
      {{ "buttons.cancel" | translate }}
    </button>
    <button type="button" nbButton status="primary" [nbSpinner]="working" [disabled]="!bucketId || working" (click)="submit()">
      {{ "pages.creator.kb.submit" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
